
import { BaseJSON,
         BaseModel,
         BaseFactory } from './models'


class ObjectModel extends BaseModel {
  constructor(
    Id_sys?: string,
    Uuid_sys?: string,
    ApiName_sys?: string,
    Label_sys?: string
  ) {
    super(Id_sys ?? "",
          Uuid_sys ?? "",
          ApiName_sys ?? "",
          Label_sys ?? "");
  }

  fromJSON(json: any): ObjectModel {
    return new ObjectModel(json.Id_sys,
                           json.Uuid_sys,
                           json.ApiName_sys,
                           json.Label_sys);
  }


}

class FieldModel {
  fieldValue: any;
  fieldName: string;
  fieldType: string;
  fieldLabel: string;
  useAsLabel: boolean;

  constructor(
    fieldValue?: any,
    fieldName?: string,
    fieldType?: string,
    fieldLabel?: string,
    useAsLabel?: boolean
  ) {
    this.fieldValue = fieldValue ?? "";
    this.fieldName = fieldName ?? "";
    this.fieldType = fieldType ?? "";
    this.fieldLabel = fieldLabel ?? "";
    this.useAsLabel = useAsLabel ?? false;
  }

  fromJSON(json: any): FieldModel {
    return new FieldModel(json.fieldValue, json.fieldName, json.fieldType, json.fieldLabel, json.useAsLabel)
  }
}

class RecordModel {
  fields: FieldModel[];
  Id_sys: string;
  Uuid_sys: string;
  LookupDisplayValue_sys: any;
  objectMetadata: ObjectModel;

  constructor(
    fields?: FieldModel[],
    Id_sys?: string,
    Uuid_sys?: string,
    LookupDisplayValue_sys?: any,
    objectMetadata?: ObjectModel
  ) {
    this.fields = fields ?? [];
    this.Id_sys = Id_sys ?? '';
    this.Uuid_sys = Uuid_sys ?? '';
    this.LookupDisplayValue_sys = LookupDisplayValue_sys ?? '';
    this.objectMetadata = objectMetadata ?? new ObjectModel();
  }

  fromJSON(json: any, objectMetadata: ObjectModel): RecordModel {
    const fields = json.fields.map((thisJSON: any) => new FieldModel().fromJSON(thisJSON));
    const id_sys = fields.find((thisField: FieldModel) => thisField.fieldName === 'Id_sys').fieldValue;
    const uuid_sys = fields.find((thisField: FieldModel) => thisField.fieldName === 'Uuid_sys').fieldValue;
    const lookupDisplayValue_sys = fields.find((thisField: FieldModel) => thisField.useAsLabel === true).fieldValue;

    return new RecordModel(fields, id_sys, uuid_sys, lookupDisplayValue_sys, objectMetadata)
  }


}

export class GlobalSearchResultModel {

  objectMetadata: ObjectModel;
  records: RecordModel[];

  constructor(
    objectMetadata?: ObjectModel,
    records?: RecordModel[]
  ) {
    this.objectMetadata = objectMetadata ?? new ObjectModel();
    this.records = records ?? [];
  }

  fromJSON(json: any): GlobalSearchResultModel {

    const objectMetadata = new ObjectModel().fromJSON(json.object_metadata);
    const records = json.records.map((thisJSON: any) => new RecordModel().fromJSON(thisJSON, objectMetadata))

    const thisSearchResult = new GlobalSearchResultModel(objectMetadata, records);

    return thisSearchResult

  }

}
